module.exports = __webpack_public_path__ + "img/pexels-nothing-ahead-7036435.37a34288.jpg";